import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BizBrandState } from './biz-brand.reducer';

// Selector to get the "bizBrand" feature state
export const selectBizBrandState = createFeatureSelector<BizBrandState>('bizBrand');

// Selector to get all community biz Brand data
export const selectAllBizBrand = createSelector(
  selectBizBrandState,
  (state: BizBrandState) => state.bizBrand
);

// Selector to get the loading state
export const selectLoading = createSelector(
  selectBizBrandState,
  (state: BizBrandState) => state.loading
);
